module.exports = __webpack_public_path__ + "images/柏纳长图_04-3.jpg?v=364add03";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_04-3.jpg
 ** module id = 141
 ** module chunks = 1 2
 **/